"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _allowance = require("@/http/interface/sfe/allowance");
var _index = require("@/utils/index");
var _moment = _interopRequireDefault(require("moment/moment"));
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** package */
/** components */
/** services */
/** utils */
var _default = exports.default = {
  data: function data() {
    return {
      role: '',
      /** page common */
      pageName: 'oilAllowance',
      /** enum */
      optConfig: {},
      /** search group */
      searchVal: {
        empNo: '',
        empName: '',
        startDay: '',
        endDay: '',
        teamType: ''
      },
      /** table group */
      table: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 10,
        sourceApi: null // api timer
      },
      /** others */
      loadingComponent: null,
      isLoading: false,
      lookupList: {}
    };
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var endDay = _this.searchVal.endDay;
          if (endDay) {
            var maxDate = (0, _moment.default)(endDay, 'YYYYMMDD').toDate();
            var minDate = (0, _moment.default)(endDay, 'YYYYMMDD').subtract(30, 'days');
            if (timeGetTime > maxDate || timeGetTime < minDate) {
              return true;
            }
          } else {
            var _maxDate = (0, _moment.default)();
            if (timeGetTime > _maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var startDay = _this.searchVal.startDay;
          if (startDay) {
            var minDate = (0, _moment.default)(startDay, 'YYYYMMDD').toDate();
            var maxDate = (0, _moment.default)(startDay, 'YYYYMMDD').add(30, 'days'); // 向后30天
            var maxDate2 = (0, _moment.default)() > maxDate ? maxDate : (0, _moment.default)();
            if (timeGetTime < minDate || timeGetTime > maxDate2) {
              return true;
            }
          } else {
            var _maxDate2 = (0, _moment.default)();
            if (timeGetTime > _maxDate2) {
              return true;
            }
          }
          return false;
        }
      };
    },
    teamType: function teamType() {
      return this.$store.getters.teamType;
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.queryEnumOptions();
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.role = this.$store.getters.roles[0];
    this.queryEnumOptions();
    this.getLookupTypeCode();
    setTimeout(function () {
      _this2.searchData();
    }, 300);
    console.log(this.role);
  },
  methods: {
    /**
     * 枚举
     */
    /** 格式化 枚举 */
    formatEnum: function formatEnum(key, from) {
      if (key) {
        return (0, _index.formatKeyValue)("".concat(key), this.optConfig[from]);
      }
      return '';
    },
    /** 获取计划类型 enum */queryEnumOptions: function queryEnumOptions() {
      // const dailySignRecordStatus_key = 'DAILY_SIGN_RECORD_STATUS' // 自身品牌 dailySignRecordStatus
      // const planTaskType_key = 'PLAN_TASK_TYPE' // 自身品牌 dailySignRecordStatus
      // const driveType_key = 'DRIVE_TYPE' // 自身品牌 dailySignRecordStatus
      // const signType_key = 'SIGN_TYPE' // 自身品牌 dailySignRecordStatus
      // const auditStatus_key = 'AUDIT_STATUS' // 自身品牌 dailySignRecordStatus
      // const param = {
      //   configItemCodeList: [dailySignRecordStatus_key, driveType_key, planTaskType_key, signType_key, auditStatus_key]
      // }
      // this.$api.common.getConfigItemByCode(param).then(res => {
      //   const data = res.data || {}
      //   this.optConfig.dailySignRecordStatusOptions = data[dailySignRecordStatus_key] || []
      //   this.optConfig.planTaskTypeOptions = data[planTaskType_key] || []
      //   this.optConfig.driveTypeOptions = data[driveType_key] || []
      //   this.optConfig.signTypeOptions = data[signType_key] || []
      //   this.optConfig.auditStatusOptions = data[auditStatus_key] || []
      //   console.log(this.optConfig.dailySignRecordStatusOptions)
      // })
    },
    /**
     * search methods
     */
    // 搜索
    searchData: function searchData() {
      this.table.currPage = 1;
      this.fetchData();
    },
    // resert saerch
    resetData: function resetData() {
      var data = this.$options.data.call(this);
      this.searchVal = data.searchVal;
      this.searchData();
    },
    /**
     * table methods
     */
    // 获取 列表
    fetchData: function fetchData() {
      var _this3 = this;
      if (this.table.sourceApi) {
        this.table.sourceApi.cancel('cancel');
      }
      this.table.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table.currPage,
        limit: this.table.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.table.listLoading = true;
      (0, _allowance.getMealAllowanceList)(param, this.table.sourceApi.token).then(function (res) {
        var _ref = res.data || [],
          items = _ref.items,
          totalCount = _ref.totalCount;
        _this3.table.list = items;
        _this3.table.total = totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this3.table.listLoading = false;
      });
    },
    // 导出excel
    downloadExcel: function downloadExcel(name) {
      var _this4 = this;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      (0, _allowance.exportMealAllowanceList)(param).then(function (res) {
        (0, _index.downloadFileExcel)(name, res.data);
      }).finally(function () {
        _this4.isLoading = false;
      });
    },
    downloadExcel2: function downloadExcel2(name) {
      var _this5 = this;
      if (!this.searchVal.startDay || !this.searchVal.endDay) {
        (0, _elementUi.Message)({
          message: '请选择日期',
          type: 'error',
          duration: 1.5 * 1000
        });
        return;
      }
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      (0, _allowance.exportWeeklyMealAllowanceList)(param).then(function (res) {
        (0, _index.downloadFileExcel)(name, res.data);
      }).finally(function () {
        _this5.isLoading = false;
      });
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this6 = this;
      var param = {
        configItemCodeList: ['TEAM_TYPE']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this6.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this6.lookupList) {
          _this6.generateMapping(key, _this6.lookupList[key] || []);
        }
        _this6.searchData();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this7 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this7.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    }
  }
};